import { lighten } from "polished";
import * as React from "react";
import { Bars } from "svg-loaders-react";
import { Colors } from "../design-tokens/colors";
import styles from "./loading-state.styles";

interface LoadingStateProps {
  height?: number;
  cover?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ height, cover }) => {
  return (
    <div css={[styles.root, !!cover && styles.rootCover]}>
      <Bars
        fill={lighten(0.3, Colors.MidGrey)}
        width={height && height < 160 ? height - 40 : 100}
        height={height && height < 160 ? height - 40 : 100}
      />
    </div>
  );
};

export default LoadingState;
